'use client';

// npm packages
import React, { useEffect, useState, useRef, useCallback } from 'react';
import classNames from 'classnames';

// components
import { useDispatch, useSelector } from 'react-redux';
import {
  openCloseCommonWarningModal,
  openCloseUnavailableFailedModal,
} from '@/redux/reducers/cart-modal-reducer';
import Text from '../Text';
import Icon from '../Icon';

function CommonWarningModal({ onClose }) {
  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const { commonWarningModal } = useSelector((state) => state.cartModal);
  // const { isOpen, text } = openRemoveUnavailableFailedModal;
  const { isOpen, text } = commonWarningModal;

  const [openModal, setOpenModal] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
      dispatch(openCloseUnavailableFailedModal({ isOpen: false, text: null }));
      dispatch(openCloseCommonWarningModal({ isOpen: false, text: null }));
    }
  }, [isOpen]);

  const handleClose = useCallback(
    (closeState) => {
      setOpenModal(closeState);
      dispatch(openCloseUnavailableFailedModal({ isOpen: false, text: null }));
      dispatch(openCloseCommonWarningModal({ isOpen: false, text: null }));
    },
    [onClose],
  );
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose(false, '');
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        dispatch(
          openCloseUnavailableFailedModal({ isOpen: false, text: null }),
        );
        dispatch(openCloseCommonWarningModal({ isOpen: false, text: null }));
        handleClose(false, false);
      }, 5000);
    }
  }, [isOpen, handleClose]);

  return (
    <div
      className={classNames(
        'w-full h-full bg-transparent flex items-end justify-center opacity-30 fixed bottom-full left-0 right-0 transition-opacity duration-100',
        {
          '!bottom-0 !opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div
        ref={modalRef}
        className={classNames(
          `w-full sm:max-w-[500px] md:!min-w-[720px]  h-[64px] flex items-center justify-between gap-[8px] sm:gap-[16px] mx-8 lg:mx-0 mb-[90px] lg:mb-10 py-12 pr-12 pl-16 md:p-16 rounded-[4px] transition-all duration-[400ms]`,
          { 'bg-infrared-burn': openModal },
        )}
      >
        <Text
          type="paragraph"
          className="text-white text-14 font-encode-sans font-medium leading-20 tracking-[0.28px]"
        >
          {text ?? ''}
        </Text>
        <div className="size-[30px">
          <Icon
            type="close"
            color="#fff"
            className="size-[24px] cursor-pointer"
            onClick={handleClose}
          />
        </div>
      </div>
    </div>
  );
}

export default CommonWarningModal;
